import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster, TooltipProvider } from 'design-system';
import { CookiesProvider } from 'react-cookie';
import { Provider as ReduxStoreProvider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { useImpostorRefresh } from '@/features/auth-access';
import { AddToAppContextProvider } from '@/features/dashboard/state/AppContext';
import { GlobalLoaderProvider } from '@/providers/GlobalLoaderProvider';
import { useFeatureFlagRefresh } from '@/services/feature-flags/useFeatureFlagRefresh';
import { SnackbarNotificationsProvider } from '@/shared/hooks/snackbarNotifications.context';

import { store } from '@/store';
import { router } from './routes';

const queryClient = new QueryClient();

const App: React.FC = () => {
  useImpostorRefresh();
  useFeatureFlagRefresh();
  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <ReduxStoreProvider store={store}>
            <AddToAppContextProvider>
              <Toaster limit={5}>
                <GlobalLoaderProvider>
                  <SnackbarNotificationsProvider>
                    <RouterProvider router={router} />
                  </SnackbarNotificationsProvider>
                </GlobalLoaderProvider>
              </Toaster>
            </AddToAppContextProvider>
          </ReduxStoreProvider>
        </TooltipProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </CookiesProvider>
  );
};

export default App;
